import React, { useState, useEffect } from "react"

import { connect } from "react-redux"

import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import ErrorIcon from "-!svg-react-loader!../../assets/icons/error-icon.svg"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { ButtonWild } from "@nutrafol/nutrafol-ui-kit/dist/ButtonWild"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"

const mageProtocol = process.env.GATSBY_MAGENTO_API_PROTOCOL
const mageURL = process.env.GATSBY_MAGENTO_API_URL

const ButtonWrap = styled.div`
  margin: ${theme.spacing.medium} 0;
`
const ErrorWrap = styled.div`
  height: 100%;
  opacity: 0;
  visibility: hidden;
  transition: all ease-in-out 0.5s;
  svg {
    margin: 0 auto;
  }
  &.show-error {
    visibility: unset;
    opacity: 1;
  }
`

const clearStateSetLocation = () => {
  if (typeof window !== `undefined`) {
    localStorage.removeItem("quizJson")
    localStorage.removeItem("userToken")
    localStorage.removeItem("quizProgress")
    localStorage.removeItem("sectionLength")
    localStorage.removeItem("currentSection")
    localStorage.removeItem("userAge")
    localStorage.removeItem("userGender")
    localStorage.removeItem("userName")
    localStorage.removeItem("subscription_id")
    localStorage.removeItem("account_user_name")
    localStorage.removeItem("customer_id")

    let linkDestination = mageProtocol + "://" + mageURL + "/hair/women/quiz/"
    window.location = linkDestination
  }
}

const Error = ({current_step, section_length}) => {

  const [show, setShow] = useState(false)

  const addFadeInClass = () => {
    setShow(true)
  }

  useEffect(() => {

    const delay = setTimeout(() => {
      addFadeInClass()
    }, 3000)

    const analyticsUrl =
      typeof window !== `undefined` ? window.location.href : undefined

    const resultsPage =
      typeof window !== `undefined`
        ? window.location.href.includes("results")
        : undefined

    const section =
      typeof window !== "undefined"
        ? window.location.href.split("/").slice(-1)[0]
        : undefined

    if (show) {
      segmentEvent("Quiz Error Viewed", {
        quiz_version: process.env.GATSBY_QUIZ_VERSION,
        section_name: section.includes("results") ? "results" : section,
        current_step: current_step + 1,
        section_length: section_length + 1,
        results_page: resultsPage,
        url: analyticsUrl,
      })
    }

    return () => clearTimeout(delay)

  }, [])

  return (
    <ErrorWrap className={`container ${!!show ? "show-error" : ""}`}>
      <Flex flexWrap="wrap" justifyContent="center" className="full-height">
        <Box width={[1, null, 1 / 4]} alignSelf="center"></Box>
        <Box width={[1, null, 1 / 2]} alignSelf="center">
          <div className="text-center">
            <ErrorIcon />
            <TextElement text="Sorry, we're busy making improvements. Please come back later." element="p" className="text-master-base-black body--regular mt-5" />
            <ButtonWrap>
              <ButtonWild
                primary
                arrowRight
                label="Start Over"
                onClick={() =>clearStateSetLocation()}
              />
            </ButtonWrap>
          </div>
        </Box>
        <Box width={[1, null, 1 / 4]} alignSelf="center"></Box>
      </Flex>
    </ErrorWrap>
  )
}

const mapStateToProps = state => {
  return {
    section_name: state.sectionReducer.currentSection,
    current_step: state.progressReducer.quizProgress,
    section_length: state.sectionLengthReducer.sectionLength,
  }
}

export default connect(mapStateToProps)(Error)
